import axios from "axios";
export default {
	data() {
		return {
			settingsPresidiOptions: [],
			settingsPresidiPathResource: "/rsasettingspresidi",
		};
	},
	methods: {
		settingsPresidiLoadData(afterLoad = null) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.settingsPresidiPathResource;
			axios.get(link)
				.then((response) => {
					me.settingsPresidiOptions = response.data.data.list;
					me.settingsPresidiOptions.unshift({ id: null, setting: "- Settings -" });
					if (afterLoad != null) {
						afterLoad();
					}
				})
				.catch((error) => {
					console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
				});
		},
	},
};
